import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Helper: ensure leading slash, drop trailing slash except for root */
function normalise(path: string): string {
  if (!path.startsWith('/')) path = '/' + path;
  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
}

/**
 * Adds .selected to every <a> that points to the current route.
 * Call this hook once in a top‑level layout component.
 */
export function useHighlightCurrentLinks() {
  const location = useLocation(); // React‑Router

  useEffect(() => {
    const current = normalise(location.pathname);

    // Tell TypeScript we expect HTMLAnchorElement nodes
    const links = document.querySelectorAll<HTMLAnchorElement>('a[href]');

    links.forEach((link) => {
      const linkPath = normalise(
        new URL(link.getAttribute('href')!, window.location.origin).pathname
      );
      link.classList.toggle('selected', linkPath === current);
    });
  }, [location.pathname]);
}
